module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jBo7Y"))).then(() => parcelRequire('hEqeo'));